import Header from "../../Common/Header";
import ResetPassword from "../ResetPassword";

const ResetPasswordPage = () => {
  return (
    <>
      <div className="bg-primary max-md:h-auto h-auto text-white">
        <Header />
        <ResetPassword />
      </div>
    </>
  );
};

export default ResetPasswordPage;
